import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slice/auth/authSlice";
import headerReducer from "./slice/header/headerSlice";
import speciesFormReducer from "./slice/form/speciesForm";
import watersFormReducer from "./slice/form/watersForm";
import restrictedFishAreaReducer from "./slice/form/restrictedFishAreaForm";

const store = configureStore({
  reducer: {
    auth: authReducer,
    header: headerReducer,
    species : speciesFormReducer,
    waters : watersFormReducer,
    restrictedFishAreas: restrictedFishAreaReducer
  },
});
export default store;
